import React, { useState, useRef, useEffect } from 'react';
import { LogOut, Check, Languages } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { t, useLanguage, chooseLanguage, LANGUAGES } from '../i18n';

function UserMenu({ userName = 'John Doe', avatarUrl = '/favicon.ico' }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef();
  const { lang } = useLanguage();

  const toggleMenu = () => setOpen(!open);

  // Close dropdown if clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    // Cached sidebar branding belongs to this login, not the next one
    localStorage.removeItem('companyBranding');
    navigate('/login');
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={toggleMenu}
        className="flex items-center space-x-1 focus:outline-none focus:ring-2 focus:ring-blue-200 rounded"
      >
        <img src={avatarUrl} alt={t('Аватар на корисникот')} className="w-9 h-9 rounded-full object-cover" />
        <span className="text-white font-semibold hidden sm:inline">{userName}</span>
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded shadow-lg z-20 py-1">
          <div className="px-4 pt-2 pb-1 flex items-center gap-2 text-xs font-medium text-gray-500 uppercase tracking-wide">
            <Languages size={14} />
            {t('Јазик')}
          </div>
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => chooseLanguage(l.code)}
              aria-pressed={lang === l.code}
              className={`w-full flex items-center justify-between px-4 py-2 text-sm hover:bg-gray-50 ${
                lang === l.code ? 'text-green-700 font-medium' : 'text-gray-700'
              }`}
            >
              <span>{l.label}</span>
              {lang === l.code && <Check size={16} />}
            </button>
          ))}
          <div className="my-1 border-t border-gray-100" />
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-2 px-4 py-2 text-red-600 hover:bg-red-50"
          >
            <LogOut size={16} />
            {t('Одјава')}
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
